import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

export interface IPaymentProcessingInfoSlice {
  paymentProcessingInfoVisible: boolean;
}

export const createPaymentProcessingInfoSliceDefaultValues = (): IPaymentProcessingInfoSlice => ({
  paymentProcessingInfoVisible: false,
});

export const createPaymentProcessingInfoSlice: StateCreator<IPaymentProcessingInfoSlice> = () =>
  createPaymentProcessingInfoSliceDefaultValues();

export type PaymentProcessingInfoPageStore = UseBoundStore<StoreApi<IPaymentProcessingInfoSlice>>;

export const createPaymentProcessingInfoHooks = (pageStore: PaymentProcessingInfoPageStore) => {
  return {
    useIsVisible: () => pageStore((state) => state.paymentProcessingInfoVisible),
  };
};

export type PaymentProcessingInfoHooks = ReturnType<typeof createPaymentProcessingInfoHooks>;
